export function uniqid(prefix = '', moreEntropy = false) {
  const timestamp = Date.now().toString(36); // Convertir timestamp a base36
  const random = Math.random().toString(36).substring(2, moreEntropy ? 10 : 5); // Generar componente aleatorio
  return prefix + timestamp + random;
}

export async function getBlobFromUrl(url) {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Error al obtener el recurso: ${response.statusText}`);
    }
    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error('Error al obtener el Blob:', error);
    return null;
  }
}

export function getBlobSize(blob) {
  if (!blob) return 0;
  return blob.size;
}

export function converStringToTime(str){
  let now = new Date();
  let [hours, minutes, seconds] = str.split(':').map(el=>parseInt(el))
  now.setHours(hours, minutes, seconds,0);
  return now 
}
// Módulo SignalR (Singleton)
const signalRService = (() => {
  let connection = null;

  // Configuración inicial de la conexión
  const createConnection = (url) => {
    if (!connection) {
      connection = new HubConnectionBuilder()
        .withUrl(url) // Reemplaza con tu URL de SignalR
        .configureLogging(LogLevel.Information)
        .withAutomaticReconnect()
        .build();

      // Manejo de reconexión
      connection.onreconnecting((error) => {
        console.warn('SignalR reconectando:', error);
      });

      connection.onreconnected((connectionId) => {
        //('SignalR reconectado con ID:', connectionId);
      });

      connection.onclose((error) => {
        console.error('SignalR conexión cerrada:', error);
      });
    }
    return connection;
  };

  // Iniciar la conexión
  const startConnection = async (url) => {
    try {
      const conn = createConnection(url);
      if (conn.state === 'Disconnected') {
        await conn.start();
        //('SignalR conectado');
      }
      return conn;
    } catch (error) {
      console.error('Error al conectar SignalR:', error);
      throw error;
    }
  };

  // Detener la conexión
  const stopConnection = async () => {
    if (connection && connection.state !== 'Disconnected') {
      await connection.stop();
      //('SignalR desconectado');
    }
  };

  // Enviar mensaje al hub
  const sendMessage = async (methodName, ...args) => {
    if (connection && connection.state === 'Connected') {
      await connection.invoke(methodName, ...args);
    } else {
      console.error('No se puede enviar mensaje: SignalR no está conectado');
    }
  };

  // Escuchar eventos del hub
  const onMessage = (methodName, callback) => {
    if (connection) {
      connection.on(methodName, callback);
    } else {
      console.error('No se puede escuchar evento: SignalR no está inicializado');
    }
  };

  // Remover listener de evento
  const offMessage = (methodName, callback) => {
    if (connection) {
      connection.off(methodName, callback);
    }
  };

  return {
    startConnection,
    stopConnection,
    sendMessage,
    onMessage,
    offMessage,
    getConnection: () => connection
  };
})();

export const signalR = signalRService;